<template>
  <div id="app">
    <!-- <div class="top_nav">
      <Nav></Nav>
    </div> -->
      <router-view></router-view>


  </div>
</template>

<script>
import Nav from "./components/nav.vue";
export default {
  name: 'App',
  components: {
    Nav
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  methods: {
    
  }
}
</script>
<style lang="scss">
#app,
body {
  margin: 0;
  padding: 0;
}
</style>
